import React from 'react'
import styles from './YearChange.module.css'

import FontAwesome from 'react-fontawesome'
import '../layouts/fontawesome/font-awesome-4.7.0/css/font-awesome.css'

export default () => {
  return (
    <div className={styles.year}>
      <div className={styles.arrowInactive}>
        <FontAwesome name="angle-double-left" />
      </div>
      <div className={styles.text}>2020 | 2021</div>
      <div className={styles.arrowInactive}>
        <FontAwesome name="angle-double-right" />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/YearChange_10_14.js